export const cacheAuthProps = {
    recentAuths: 'logins',
    userTokens: 'userTokens',
    userRole: 'userRole',
    verifyUser: 'verify_user',
    authedWorkspace: 'authedWorkspace',
};
